import Divider from '@mui/material/Divider';

export const HorizontalDivider = ({sx}) => <Divider style={{width: '100%', ...sx}} />;
